import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectObjectSizeMappings = createSelector(
  [
    (state: ApplicationState) => state.ObjectSizeMapperStore,
    (_: ApplicationState, customerId: string) => customerId
  ],
  (store, customerId) => store[customerId] ?? []
)
